import { Component, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'withdraw-modal-wettarena-component',
  templateUrl: './withdraw-modal-wettarena.component.html',
})
export class WithdrawModalWettarenaComponent {
  WithdrawFormDatas: UntypedFormGroup;

  WithdrawFormRaw: any;
  MinValue: any;
  MaxValue: any;
  @Output() dataChangedCallback = new EventEmitter<any>();

  //Default Paypal
  selectedWithdraw = {
    withdrawTypeId: 12,
    withdrawName: 'Paypal',
    minValue: 10,
    maxValue: 50,
  };
  constructor(
    public dialogRef: MatDialogRef<WithdrawModalWettarenaComponent>,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.route.params.subscribe(params => {
      this.getWithDrawInfo();
    });

    this.setSelectWithdraw();

    if (this.selectedWithdraw.withdrawTypeId === 73) {
      this.WithdrawFormDatas = _FormBuilder.group({
        withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(this.data.minValue), Validators.maxLength(this.data.maxValue)]),
        phoneNumber: new UntypedFormControl({ value: '', disabled: false }, [Validators.minLength(10), Validators.maxLength(15), Validators.required]),
        transactionTypeId: new UntypedFormControl({ value: '' }),
      });
    } else {
      this.WithdrawFormDatas = _FormBuilder.group({
        withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(this.data.minValue), Validators.maxLength(this.data.maxValue)]),
        mailadress: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
        transactionTypeId: new UntypedFormControl({ value: '' }),
      });
    }
  }

  setSelectWithdraw() {
    this.selectedWithdraw.withdrawName = this.data.PaymentType;
    this.selectedWithdraw.withdrawTypeId = this.data.WithdrawTypeId;
    this.selectedWithdraw.minValue = this.data.minValue;
    this.selectedWithdraw.maxValue = this.data.maxValue;
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('withdrawReq', true);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getWithDrawInfo() {
    this._ApiService.getAllWithdrawControl().then(result => {
      //console.log("getDeposit--",result.filter(item => item.DepositTypeId == this.DepositTypeId));

      const WithDrawInfo = result;

      if (WithDrawInfo.length > 0) {
        this.MinValue = WithDrawInfo[0].MinValue;
        this.MaxValue = WithDrawInfo[0].MaxValue;
        if (this.data.amount) {
          this.WithdrawFormDatas.controls.withdrawamount.setValue(this.data.amount);
        } else {
          this.WithdrawFormDatas.controls.withdrawamount.setValue('');
        }

        this.WithdrawFormDatas.valueChanges.subscribe(x => {
          this.WithdrawFormRaw = x;
        });
        this.dataChangedCallback.emit(true);
      }
    });
  }

  submitWithdraw() {
    this.WithdrawFormDatas.controls.transactionTypeId.setValue(this.selectedWithdraw.withdrawTypeId);
    this._UiHelper.setLoadingDialog(true);

    this._ApiService.generalWithdraw(this.WithdrawFormRaw).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      ////console.log("COIN_BASE_WITHDRAW", result);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          //window.location = result.message;

          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.successSnackBar(t_message, '');

          this.WithdrawFormDatas.patchValue({ withdrawamount: '' });

          this._ApiService
            .getClient()
            .then(t => {
              this._UserHelper.updateUser(t);
            })
            .catch();
          this.closeDialog();
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
